import { CustomValidateResolveType } from 'tdesign-react';

const validateText: (
  value: string | undefined | null,
  name: string,
) => CustomValidateResolveType = (value, name) => {
  if (value && typeof value === 'string' && value.trim() !== '') {
    return true;
  }

  return { result: false, message: `请填写${name}`, type: 'error' };
};

export { validateText };
